/* eslint import/no-anonymous-default-export: [2, {"allowObject": true}] */
export default {
  root: {},
  notchedOutline: {
    borderColor: 'rgba(0,0,0,0.15)'
  }
};
